<template>
    <div class="parent">
      <div class="kattaPrixod">
        <span>
          Реагентлар расходи
        </span>
        <b-button class="navbarBtnDanger" variant="danger" @click="Prev()">
          <b-icon icon="x-circle-fill"></b-icon>
        </b-button>
      </div>
      <div
        class="pastavshik"
        :class="{ Arxive: $route.name == 'Prixod Document' }"
      >
        <div style="width: 24%;">
          <label>{{ $t("Вақт") }}</label>
          <date-picker
            style="width: 100%;"
            format="DD.MM.YYYY"
            v-model="formData.datetime"
            value-type="X"
            type="date"
            disabled
            :lang="lang"
          ></date-picker>
        </div>
        <div style="width: 24%; position: relative;">
          <label>
            Текширув бўлими
          </label>
          <v-select
            label="name"
            class="qidiruvselect"
            v-model="formData.ins_cat_id"
            :options="categories"
            :reduce="option => option.id"
          />
        </div>
        <!-- <div style="width: 24%;">
          <label>
            Жами сони
          </label>
          <vue-numeric
            style="width: 100%; height: 38px; background: #fff; border-radius: 4px; border: 1px solid #ced4da;"
            :disabled="true"
            separator="space"
            :precision="2"
            v-model="formData.all_count"
          ></vue-numeric>
        </div> -->
        <!-- <div style="width: 24%;">
          <label>{{ $t("Изоҳ") }}</label>
          <b-input
            type="text"
            style="background: #fff; border: 1px solid #ced4da;"
            v-model="prixod.comment"
          ></b-input>
        </div> -->
      </div>
      <div
        class="pastavshiktable"
        :class="{ Arxive: $route.name == 'Prixod Document' }"
      >
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th style="width: 300px;">{{ $t("Махсулот") }}</th>
              <th>{{ $t("Сони") }}</th>
              <th>Қолдиқ</th>
              <th style="width: 50px;">#</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in formData.childs" :key="index">
              <td>{{ index + 1 }}</td>
              <td style="position: relative;">
                <!-- <button
                  class="tabsBtnsstd"
                  v-b-modal="'OpenModalReagent' + index"
                >
                  ...
                </button> -->
                <v-select
                  class="qidiruvselect"
                  label="name"
                  v-model="item.reagent_id"
                  :options="Maxsulot"
                  :reduce="option => option.id"
                  @input="changeReagent($event, index)"
                />
              </td>
              <td>
                <b-input
                  style="background: #fff; border: 1px solid #ced4da;"
                  v-model="item.count"
                  type="number"
                ></b-input>
              </td>
              <td>
                <vue-numeric
                  style="width: 100%; height: 38px; border-radius: 4px; border: 1px solid #ced4da;"
                  separator="space"
                  :disabled="true"
                  :precision="2"
                  v-model="item.balance"
                ></vue-numeric>
              </td>
              <td>
                <b-button
                  class="trash1"
                  style=""
                  variant="outline-danger"
                  @click="daleteSubrow(item, index)"
                >
                  <b-icon
                    style="width: 15px;"
                    icon="trash-fill"
                    aria-hidden="true"
                  ></b-icon>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
        <b-button class="qoshish_Btn" variant="primary" @click="add"
          ><b-icon icon="plus" font-scale="2" color="#fff"></b-icon
        ></b-button>
      </div>
      <div class="tugmalar">
        <div>
          <b-button
            @click="createPrixod()"
            class="mr-2 calendar"
            variant="success"
          >
            <b-icon icon="calendar2-plus"></b-icon> {{ $t("Сақлаш") }}
          </b-button>
          <b-button @click="cancel()" class="calendar1" variant="danger">
            <b-icon icon="calendar2-x"></b-icon> {{ $t("Бекор қилиш") }}
          </b-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import DatePicker from "vue2-datepicker";
  import { required, minLength } from "vuelidate/lib/validators";
  import "vue2-datepicker/index.css";
  export default {
    name: "reagent-form",
    components: {
      DatePicker
    },
    data() {
      return {
        formData: {
          datetime: new Date()
            .valueOf()
            .toString()
            .slice(0, 10),
          all_count: 0,
          ins_cat_id: null,
          comment: "",
          childs: []
        },
        provider: {
          name: ""
        },
        reagent: {
          name: ""
        },
        errors: null,
        errorPastavshik: null,
        errorReagent: null,
        lang: {
          formatLocale: {
            firstDayOfWeek: 1
          },
          monthBeforeYear: false
        },
        categories: [],
        Maxsulot: []
      };
    },
    validations: {
      formData: {
        all_count: {
          required
        },
        ins_cat_id: {
          required
        }
      },
      provider: {
        name: {
          required,
          minLength: minLength(4)
        }
      },
      reagent: {
        name: {
          required,
          minLength: minLength(4)
        }
      }
    },
    methods: {
      changeCount() {

      },
      Prev() {
        if (this.$route.name != "Prixod Document") {
          const x = window.confirm(
            this.$t("Ростдан ҳам ойнани тарк этмоқчимисиз")
          );
          if (x) {
            this.$router.push("/prixod");
          }
        } else {
          window.close();
        }
      },
      changeReagent(e, index) {
        let self = this;
        axios({
          method: "get",
          url: "/manual-rasxod-reagent/balance/" + e
        }).then(res => {
          if (res != undefined) {
            let balance = res.data.balance;
            self.formData.childs[index].balance = balance;
          }
        });
      },
      getAllCategory() {
        let self = this;
        axios({
          method: "get",
          url: "/inspector_category/all"
        }).then(res => {
          if (res != undefined) {
            self.categories = res.data.data;
          }
        });
      },
      createPrixod() {
        let self = this;
        // this.$v.$touch();
        if (this.$v.formData.$error == false) {
          if (self.$route.name == "ManualRasxodReagentCreate") {
            axios({
              method: "post",
              url: "/manual-rasxod-reagent/create",
              data: self.formData
            }).then(data => {
              if (data != undefined) {
                this.$router.push("/manual-rasxod-reagent");
              }
            });
          } else if (self.$route.name == "ManualRasxodReagentUpdate") {
            axios({
              method: "patch",
              url: `/manual-rasxod-reagent/update/` + self.formData.id,
              data: self.formData
            }).then(data => {
              if (data != undefined) {
                self.$router.push("/manual-rasxod-reagent");
              }
            });
          }
        } else {
          self.errors = self.$v.formData;
        }
      },
      getPrixod() {
        let self = this;
        if (self.$route.name != "ManualRasxodReagentCreate") {
          axios({
            method: "get",
            url: `/manual-rasxod-reagent/one/` + self.$route.params.id
          }).then(res => {
            if (res != undefined) {
              self.formData = res.data
            }
          });
        }
      },
      getMaxsulot() {
        let self = this;
        axios({
          method: "get",
          url: "/reagent/all"
        }).then(res => {
          if (res != undefined) {
            self.Maxsulot = res.data.data;
          }
        });
      },
      add() {
        this.formData.childs.push({
          reagent_id: null,
          ins_cat_id: this.formData.ins_cat_id,
          count: 0,
          balance: 0
        });
      },
      cancelPastavshik() {
        this.provider = {
          name: ""
        };
      },
      cancelReagent() {
        this.reagent = {
          name: ""
        };
      },
      cancel() {
        this.prixod.umumiy_summa = 0;
        this.prixod.pastavchik_id = null;
        this.prixod.comment = "";
        this.prixod.childs = [
          {
            reagent_id: null,
            price: 0,
            summa: 0,
            count: 0
          }
        ];
        // this.prixod = {
        //   umumiy_summa: 0,
        //   pastavchik_id: null,
        //   comment: "",
        //   childs: [
        //     {
        //       reagent_id: null,
        //       price: 0,
        //       summa: 0,
        //       count: 0
        //     }
        //   ]
        // };
      },
      daleteSubrow(item, index) {
        this.prixod.umumiy_summa -= Number(item.count) * Number(item.price);
        this.prixod.childs.splice(index, 1);
      }
    },
    mounted() {
      this.getPrixod();
      this.getAllCategory();
      this.getMaxsulot();
    }
  };
  </script>
  <style>
  .kattaPrixod {
    margin: 0px auto;
    padding: 10px 7px;
    width: 99%;
    background: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5);
    display: flex;
    justify-content: space-between;
    color: #3f51b5;
    font-size: 20px;
    font-weight: 700;
    line-height: 40px;
    /* background: #007bff; */
    /* margin-top: -25px; */
    /* margin-left: 10px;
    margin-right: 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    font-weight: 700;
    line-height: 40px;
    border-radius: 8px;
    color: #3f51b5;
    text-indent: 15px; */
    /* box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5); */
  }
  .btnlar {
    justify-content: right;
    display: flex;
    margin-top: 20px;
  }
  .pastavshiktable {
    width: 99%;
    margin: 0 auto;
    background: #fff;
    overflow: auto;
    height: calc(100vh - 280px);
  }
  .tabsBtnss {
    position: absolute;
    z-index: 99;
    top: 44px;
    left: calc(100% - 70px);
    color: #b1b1b1;
    font-weight: 700;
    font-size: 17px;
    border: none;
    background-color: white;
  }
  .tabsBtnsstd {
    position: absolute;
    z-index: 99;
    top: 14px;
    left: calc(100% - 70px);
    color: #b1b1b1;
    font-weight: 700;
    font-size: 17px;
    border: none;
    background-color: white;
  }
  .qidiruvselect .vs__dropdown-toggle {
    height: 38px;
    background: #fff;
  }
  .parent {
    background: #d3e4e7;
    height: 100vh;
    box-sizing: border-box;
  }
  .navbarBtnDanger {
    border: 1px solid #fff;
    box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.3);
    background: #e80a18;
    border-radius: 8px;
  }
  .qoshish_Btn {
    position: absolute;
    right: 60px;
    bottom: 100px;
    /* left: 990px; */
    background: #195fb0;
    margin-top: 5px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #195fb0;
    box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
  }
  .shirift {
    font-size: 16px;
    font-weight: 400;
  }
  .trash1 {
    background: #fff;
    width: 35px;
    height: 35px;
    display: flex;
    border: 1px solid #fadddd;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .pastavshik {
    margin: 20px auto 0;
    /* padding: 5px; */
    border-radius: 7px;
    background: #00009d;
    margin-bottom: 20px;
    padding: 7px 5px;
    /* background: #fff; */
    border: 1px solid #fff;
    width: 99%;
    display: flex;
    justify-content: space-between;
  }
  .pastavshik label {
    color: #ffff;
    font-size: 18px;
    font-weight: 600;
  }
  .Arxive {
    pointer-events: none;
  }
  .pastavshiktable th {
    background: #2a2aa8 !important;
    color: #fff;
  }
  .tugmalar {
    position: absolute;
    right: 20px;
    bottom: 20px;
    display: flex;
    justify-content: right;
  }
  .calendar1 {
    box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.5);
  }
  .calendar {
    box-shadow: 5px 8px 10px rgba(25, 176, 48, 0.5);
  }
  </style>
  